import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Box, Spinner } from '@chakra-ui/react';

export default function ProtectedRoute({ children, role }) {
  const { user, isAuthChecked } = useAuth();

  if (!isAuthChecked) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="brand.black">
        <Spinner color="brand.coral" size="xl" />
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === 'ADMIN' ? '/admin' : '/agent'} replace />;
  }

  return children;
}
